// React imports not needed - using JSX transform

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

/**
 * Loading component with accessible attributes
 */
export function Loading({ message = 'Loading...', fullScreen = false }: LoadingProps) {
  const baseClasses = 'flex flex-col items-center justify-center p-8';
  const containerClasses = fullScreen
    ? `${baseClasses} min-h-screen`
    : `${baseClasses} min-h-[200px]`;

  return (
    <div className={containerClasses} role="status" aria-live="polite" aria-busy="true">
      <div
        className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"
        aria-hidden="true"
      />
      <span className="mt-4 text-sm text-gray-600">{message}</span>
    </div>
  );
}

/**
 * Skeleton loader for product cards
 */
export function ProductCardSkeleton() {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm animate-pulse">
      <div className="h-6 w-3/4 rounded bg-gray-200" />
      <div className="mt-4 h-4 w-1/2 rounded bg-gray-200" />
      <div className="mt-4 h-4 w-1/4 rounded bg-gray-200" />
    </div>
  );
}

/**
 * Skeleton loader for product list
 */
export function ProductListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}
